import { MAIN_CASINO_PATH } from './mainCasinoRoute'

const TAB_CDN = 'https://dmcegeg7oly4.cloudfront.net/empwr/tabs'

export type LotusCasinoTab = {
  id: string
  title: string
  image: string
  tabIndex: number
  /** Category query value, route path, or special view key */
  target: string
  targetType: 'lobby' | 'category' | 'route'
  /** For route tabs that stay on a casino-int page (e.g. indian games → other) */
  casinoType?: string
  defaultCategory?: string
}

export const LOTUS_CASINO_TABS: LotusCasinoTab[] = [
  { id: 'lobby', title: 'Lobby', tabIndex: 1, image: `${TAB_CDN}/lobby.webp`, target: 'lobby', targetType: 'lobby' },
  {
    id: 'indian-games',
    title: 'Indian Games',
    tabIndex: 4,
    image: '/imgs/casino-tabs/indian_games.webp',
    target: 'Mac88',
    targetType: 'category',
  },
  { id: 'recommended', title: 'Recommended', tabIndex: 15, image: `${TAB_CDN}/recommended.webp`, target: '100hp', targetType: 'category' },
  { id: 'evolution', title: 'Evolution', tabIndex: 3, image: `${TAB_CDN}/evolution.webp`, target: 'Evolution Live', targetType: 'category' },
  { id: 'teen-patti', title: 'Teen Patti', tabIndex: 5, image: `${TAB_CDN}/teen_patti.webp`, target: '100hp', targetType: 'category' },
  { id: 'roulette', title: 'Roulette', tabIndex: 6, image: `${TAB_CDN}/roulette.webp`, target: 'Evolution Live', targetType: 'category' },
  { id: 'baccarat', title: 'Baccarat', tabIndex: 7, image: `${TAB_CDN}/baccarat.webp`, target: 'Evolution Live', targetType: 'category' },
  { id: 'instant-games', title: 'Instant Games', tabIndex: 8, image: `${TAB_CDN}/instant_games.webp`, target: 'Spribe', targetType: 'category' },
  { id: 'game-shows', title: 'Game Shows', tabIndex: 9, image: `${TAB_CDN}/game_shows.webp`, target: 'Evolution Live', targetType: 'category' },
  { id: 'dragon-tiger', title: 'Dragon Tiger', tabIndex: 10, image: `${TAB_CDN}/dragon_tiger.webp`, target: 'Ezugi', targetType: 'category' },
  { id: 'blackjack', title: 'Blackjack', tabIndex: 11, image: `${TAB_CDN}/blackjack.webp`, target: 'Evolution Live', targetType: 'category' },
  { id: 'poker', title: 'Poker', tabIndex: 12, image: `${TAB_CDN}/poker.webp`, target: 'Evolution Live', targetType: 'category' },
  { id: 'slots', title: 'Slots', tabIndex: 13, image: `${TAB_CDN}/slots.webp`, target: '100hp', targetType: 'category' },
  { id: 'sicbo', title: 'Sicbo', tabIndex: 14, image: `${TAB_CDN}/sic-bo.webp`, target: 'Ezugi', targetType: 'category' },
  { id: 'sport-games', title: 'Sport Games', tabIndex: 17, image: '/imgs/super-casino-tabs/sport_games.svg', target: '100hp', targetType: 'category' },
]

export const LOTUS_CASINO_DEFAULT_PATH = MAIN_CASINO_PATH

export function getLotusTabByIndex(tabIndex: number): LotusCasinoTab | undefined {
  return LOTUS_CASINO_TABS.find((t) => t.tabIndex === tabIndex)
}

export function getLotusTabPath(tabIndex: number): string {
  return `/casino-int/tab/${tabIndex}`
}

export function getLotusTabByCategory(category: string | null | undefined): LotusCasinoTab | undefined {
  if (!category) return undefined
  return LOTUS_CASINO_TABS.find((t) => t.targetType === 'category' && t.target === category)
}

export function parseLotusTabIndexFromPath(pathname: string): number | null {
  const match = pathname.match(/\/casino-int\/tab\/(\d+)/)
  if (!match) return null
  const n = parseInt(match[1], 10)
  return Number.isFinite(n) ? n : null
}
